import { useMediaQuery } from "@mui/material";
import { getImageUrl } from "helpers";


const ProxyManagementCountry = ({ data, bg }) => {
    const { icon, text } = data;
    const Icon = getImageUrl(icon);
    const isTablet = useMediaQuery('max-width: 768px')

    return (
        <div className='management-item'>
            <div className='management-item__icon'><img src={Icon} alt="" /></div>
            <div className='body2'>{text}</div>
            {!isTablet && <img className="management-item-mob-bg" src={bg} alt="" />}
        </div>
    );
}

export default ProxyManagementCountry;